import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import auth from '../middleware/auth';
import auth_no_special_customer from '../middleware/auth_no_special_customer';
import un_auth from '../middleware/un_auth';

const routes = [
  {
    //===== MAIN LAYOUT CLIENTS ====
    path: '/cliente',
    component: () => import('../layouts/ClientsApp.vue'),
    children: [
      {
        path: '',
        name: 'cliente-inicio',
        component: () => import('../views/clients/Advertisements'),
        meta: {
          title: 'Anuncios',
          middleware: [auth],
        },
      },
      {
        path: 'anuncios',
        name: 'cliente-anuncios',
        component: () => import('../views/clients/Advertisements'),
        meta: {
          title: 'Anuncios',
          middleware: [auth],
        },
      },
      {
        path: 'promociones',
        name: 'cliente-promociones',
        component: () => import('../views/clients/Promotions'),
        meta: {
          title: 'Promociones',
          middleware: [auth],
        },
      },
      {
        path: 'comprar-promociones',
        name: 'cliente-comprar-promociones',
        component: () => import('../views/clients/PurchasePromotions'),
        meta: {
          title: 'Promociones',
          middleware: [auth_no_special_customer],
        },
      },
      {
        path: 'comprar',
        name: 'cliente-comprar',
        component: () => import('../views/clients/Purchase'),
        meta: {
          title: 'Comprar',
          middleware: [auth],
        },
      },
      {
        path: 'cart',
        name: 'cart',
        component: () => import('../views/clients/CartPage'),
        meta: {
          title: 'Carrito de compraas',
          middleware: [auth],
        },
      },
      {
        path: 'confirmar-orden',
        name: 'checkout',
        component: () => import('../views/clients/CheckoutPage'),
        meta: {
          title: 'Confirmar',
          middleware: [auth],
        },
      },
      {
        path: 'ticket/:order_id',
        name: 'ticket',
        component: () => import('../views/clients/TicketPage'),
        props: true,
        meta: {
          title: 'Ticket',
          middleware: [auth],
        },
      },
      {
        path: 'pedidos',
        name: 'cliente-pedidos',
        component: () => import('../views/clients/Orders'),
        meta: {
          title: 'Mis pedidos',
          middleware: [auth],
        },
      },
      {
        path: 'perfil',
        name: 'cliente-perfil',
        component: () => import('../views/clients/Profile'),
        meta: {
          title: 'Mis perfil',
          middleware: [auth],
        },
      }
    ]
  },
  {
    path: '/',
    component: () => import('../layouts/PublicApp.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('../views/public/Home'),
        meta: {
          title: 'Inicio'
        }
      },
      {
        path: 'login',
        name: 'login',
        component: () => import('../views/public/Login'),
        meta: {
          title: 'Iniciar sesión',
          middleware: [un_auth],
        }
      },
      {
        path: 'recuperar-accesos',
        name: 'recuperar-contrasena',
        component: () => import('../views/public/Login'),
        meta: {
          title: 'Iniciar sesión',
          middleware: [un_auth],
        }
      }
    ],
  },
];

const router = new VueRouter({
  routes
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	// If no subsequent Middleware exists,
	// the default `next()` callback is returned.
	if (!subsequentMiddleware) return context.next;

	return (...parameters) => {
		// Run the default Vue Router `next()` callback first.
		context.next(...parameters);
		// Then run the subsequent Middleware with a new
		// `nextMiddleware()` callback.
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({ ...context, next: nextMiddleware });
	};
}

router.afterEach(() => {
  // 
})

router.beforeEach((to, from, next) => {
	if (to.meta.middleware) {
		const middleware = Array.isArray(to.meta.middleware)
			? to.meta.middleware
			: [to.meta.middleware];

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({ ...context, next: nextMiddleware });
	}

	return next();
});

export default router;
